<template>
  <svg
    width="28px"
    height="40px"
    viewBox="0 0 28 40"
    version="1.1"
  >
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="marker"
        :fill="fillColor"
      >
        <path
          id="Shape"
          d="M14,19 C11.24,19 9,16.76 9,14 C9,11.24 11.24,9 14,9 C16.76,9 19,11.24 19,14 C19,16.76 16.76,19 14,19 M14,0 C6.26,0 0,6.26 0,14 C0,24.5 14,40 14,40 C14,40 28,24.5 28,14 C28,6.26 21.74,0 14,0"
        ></path>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    fillColor: {
      type: String,
      required: true,
    },
  },
};
</script>
